import ddt from '@wix/da-ddt';
import findIndex from 'lodash/findIndex';
export function getFeature(type, features) {
    if (typeof features === 'string') {
        try {
            features = JSON.parse(features);
        } catch (e) {
            ddt.error('draftjs', 'Failed to parse journal features', e);
        }
    }
    if (typeof features === 'string') {
        return; // TS..
    }
    const idx = findIndex(features, [
        'type',
        type
    ]);
    return features[idx] || undefined;
}
